import React, {Component}  from 'react';
import {
  Panel
}                           from 'react-bootstrap';
import Pagination           from "react-js-pagination";

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import Table                from './Table';

import {REDEMPTION_SUMMARY} from 'actions/const';

class RedemptionSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 1,
      isLoading: false,
      isExporting: false,
      showModal: false,
      selectedData: null
    };

    this.stateSetter = this.stateSetter.bind(this);
    this.handlePaginate = this.handlePaginate.bind(this);
    this.getTableData = this.getTableData.bind(this);
  }

  stateSetter(stateArray) {
    for (var i in stateArray) {
      this.setState({ [stateArray[i].state]: stateArray[i].value }, () => {
        if (stateArray[i].state === 'filterUser') {
          this.getAccessList();
        }
      });
    }
  }

  handlePaginate(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      this.getTableData();
    });
  }


  getTableData() {
    this.setState({ isLoading: true });

    let {
      activePage
    } = this.state;

    let {
      setValue
    } = this.props.actions;

    let {
      limit,
      filterNid,
      filterCouponName
    } = this.props.redemptionsummary;

    const isUndefined = (obj) => typeof obj === 'undefined' ? true : false;

    const isNull = (obj) => obj == null
      ? true
      : false;

    const getValue = (obj) => isNull(obj)
      ? ''
      : obj.value;

    var redemptionLogQuery =  new Parse.Query('RedemptionLog');

    var user = Parse.User.current();

    if (!isUndefined(user.get('userType'))) {
      if (user.get('userType').toUpperCase() === 'MERCHANT') {
				if (!isUndefined(user.get('Merchant'))) {
          redemptionLogQuery.equalTo('merchantName', user.get('Merchant').get('name'));
				}
      }
    }

    if (!isNull(filterNid) && filterNid !== '') {
      console.log('undefined test');
      redemptionLogQuery.matches('nid', filterNid, 'i');
    }

    if (!isNull(filterCouponName) && filterCouponName !== '') {
      redemptionLogQuery.matches('couponName', filterCouponName, 'i');
    }

    redemptionLogQuery.distinct('nid')
    .then((data) => {
      var countQuery = [];
      var couponNameQuery = [];

      for (var nidObj of data) {
        redemptionLogQuery =  new Parse.Query('RedemptionLog');
        redemptionLogQuery.equalTo('nid', nidObj);
        countQuery.push(redemptionLogQuery.count());

        redemptionLogQuery.select(['couponName']);
        redemptionLogQuery.exists('couponName');
        couponNameQuery.push(redemptionLogQuery.first());
      }
      return new Promise((resolve, reject) => {
        var count;
        Promise.all(countQuery)
        .then((data2) => {
          count =  data2;
          return Promise.all(couponNameQuery);
        })
        .then((data3) => {
          var object = [];
          for (var i in data3) {
            object.push({
              nid: data[i],
              count: count[i],
              couponName: data3[i].get('couponName')
            });
          }
          resolve(object);
        })
        .catch((err) => {
          reject(err)
        })
      });
    })
    .then((data) =>  {
      console.log('count data: ', data);
      setValue(REDEMPTION_SUMMARY, 'tableData', data);
      setValue(REDEMPTION_SUMMARY, 'totalRecord', data.length);
      this.setState({ isLoading: false });
    })
    .catch((err) => {
      console.error('Distinct error: ', err);
      this.setState({ isLoading: false });
    });
  }

  render() {
    let {
      activePage,
      isLoading,
      isExporting,
      showModal,
      selectedData
    } = this.state;

    let {
      limit,
      totalRecord
    } = this.props.redemptionsummary;

    let tableProps = {
      isLoading,
      getTableData: this.getTableData
    };

    let paginationProps = {
      activePage: activePage,
      itemsCountPerPage: limit,
      totalItemsCount: totalRecord,
      pageRangeDisplayed: 5,
      onChange: this.handlePaginate
    };

    return (
      <Panel>
        <Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
          <h4>Redemption Summary</h4>
        </Panel.Heading>
        <Panel.Body>
					<Table {...tableProps}/>
          <div>Total Records: {totalRecord}</div>
          {/*<Pagination {...paginationProps}/>*/}
				</Panel.Body>
      </Panel>
    );
  }

  componentDidMount() {
    this.getTableData()
  }
}

function mapStateToProps(state) {
	var {redemptionsummary, accessjson} = state;
	const props = {
		redemptionsummary,
    accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(RedemptionSummary);



// WEBPACK FOOTER //
// ./components/RedemptionSummary/index.js